import { useSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DenseAppBar from "../../components/AppBar";
import Filters from "../../components/Filters";
import Input from "../../components/Input";
import AlertModal from "../../components/Modal";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import {
  getCurrency,
  getDateTime,
  truncateString
} from "../../helpers/Functions";
import Checked from "../../images/check.png";
import Copy from "../../images/copy.png";
import { Reducers } from "../../Interfaces/Interfaces";
import { getAgentByPhoneNumber } from "../../redux/actions/AgentActions";
import { fileUpload } from "../../redux/actions/configActions";
import {
  complaintDashboard,
  createBillComplaintAction,
  createFinanceComplaintAction,
  createGeneralComplaintAction,
  createPOSComplaintAction,
  createSavingsComplaintAction,
  getBillTypesAction,
  getJiraRequestLog
} from "../../redux/actions/JiraActions";
import PrimaryTheme from "../../Themes/Primary";
import "./logs.scss";
import SimplePopover from "./LogViews";
export default function Logs() {
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);
  const getAllegents = useSelector((state: any) => state.getAllegents);
  const getBillType = useSelector((state: any) => state.getBillType);
  const dashboard: Dashboard = useSelector(
    (state: Reducers) => state.complaintDashboard
  );
  const file = useSelector((state: Reducers) => state.file);
  const logs = useSelector((state: Reducers) => state.logs);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [searchState, setSearchState] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [status, setStatus] = React.useState("");
  const [type, setType] = React.useState("");
  const [Agent, setAgent] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [AgentName, setAgentName] = React.useState("");
  const [ComplainType, setComplainType] = React.useState("0");
  const [ComplainMessage, setComplainMessage] = React.useState("");
  const [AgentId, setAgentId] = React.useState("");

  const [utility] = React.useState("");

  const [submitted] = React.useState(false);
  const [utilityName, setUtilityName] = React.useState("Choose file...");
  const [BillType, setBillType] = React.useState("0");
  const [Reference, setReference] = React.useState("");
  const [Beneficiary, setBeneficiary] = React.useState("");

  const [Amount, setAmount] = React.useState("");
  const [TerminalId, setTerminalId] = React.useState("");

  const [MaskPan, setMaskPan] = React.useState("");
  const [CustomerName, setCustomerName] = React.useState("");
  const [ChoosenData, setChoosenData]: any = React.useState("");
  const [disabledButton, setdisabledButton] = React.useState(true);
  const [ComplainSuccessModal, setComplainSuccessModal] = React.useState(false);
  const [ButtonLoader, setButtonLoader] = React.useState(false);
  const [ResponseMessage, setResponseMessage] = React.useState("");
  const [complainErrorMessage, setcomplainErrorMessage] = React.useState("");
  React.useEffect(() => {
    if (
      ComplainType === "0" &&
      ComplainMessage !== "" &&
      Reference !== "" &&
      AgentId !== ""
    ) {
      setChoosenData({
        message: ComplainMessage,
        fileUploadUrl: file.fileName,
        channel: 1,
        reference: Reference,
        agentId: AgentId,
      });
      setdisabledButton(false);
    } else if (
      ComplainType === "1" &&
      ComplainMessage !== "" &&
      AgentId !== "" &&
      BillType !== "" &&
      Reference !== "" &&
      Beneficiary !== "" &&
      Amount !== ""
    ) {
      setChoosenData({
        message: ComplainMessage,
        fileUploadUrl: file.fileName,
        beneficiary: Beneficiary,
        billType: BillType,
        channel: 1,
        amount: Amount,
        reference: Reference,
        agentId: AgentId,
      });
      setdisabledButton(false);
    } else if (
      ComplainType === "2" &&
      ComplainMessage !== "" &&
      AgentId !== "" &&
      MaskPan !== "" &&
      Reference !== "" &&
      TerminalId !== "" &&
      Amount !== ""
    ) {
      setChoosenData({
        message: ComplainMessage,
        fileUploadUrl: file.fileName,
        reference: Reference,
        terminalId: TerminalId,
        channel: 1,
        amount: Amount,
        maskedPan: MaskPan,
        agentId: AgentId,
      });
      setdisabledButton(false);
    } else if (
      ComplainType === "3" &&
      ComplainMessage !== "" &&
      Reference !== "" &&
      AgentId !== "" &&
      Amount !== ""
    ) {
      setChoosenData({
        message: ComplainMessage,
        fileUploadUrl: file.fileName,
        channel: 1,
        amount: Amount,
        reference: Reference,
        agentId: AgentId,
      });
      setdisabledButton(false);
    } else if (
      ComplainType === "4" &&
      CustomerName !== "" &&
      ComplainMessage !== "" &&
      AgentId !== "" &&
      Reference !== "" &&
      Amount !== ""
    ) {
      setChoosenData({
        customerPhoneNumber: CustomerName,
        amount: Amount,
        message: ComplainMessage,
        fileUploadUrl: file.fileName,
        channel: 1,
        reference: Reference,
        agentId: AgentId,
      });
      setdisabledButton(false);
    } else {
      setdisabledButton(true);
    }
  }, [
    BillType,
    Reference,
    Beneficiary,
    Amount,
    TerminalId,
    MaskPan,
    CustomerName,
    ComplainType,
    ComplainMessage,
    AgentId,
  ]);
  // setComplainMessage
  let list = logs && logs.items;

  let filter: any = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    setPageSize(value.props.value);
    paginationConfig.pageSize = value.props.value;

    dispatch({
      type: "LOADING",
      payload: true,
    });

    dispatch(getJiraRequestLog(paginationConfig));
  };

  const handleReconfirm = (ref: any) => {
    setAnchorEl(null);

    dispatch(getJiraRequestLog(paginationConfig));

    dispatch({
      type: "LOADING",
      payload: true,
    });
  };

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    dispatch(getJiraRequestLog(paginationConfig));
    dispatch(complaintDashboard());
  };
  const handleFile = (e: any, type: string) => {
    let pic = e[0];
    let fd = new FormData();
    if (pic) {
      fd.append("imageUrl", pic);

      dispatch(fileUpload(fd, type));
      dispatch({
        type: "LOADING",
        payload: true,
      });
    }
  };
  const getColor = (status: any) => {
    switch (status) {
      case 1:
        return "badge-info";
      case 2:
        return "badge-warning";
      case 3:
        return "badge-success";
      default:
        return "badge-info";
    }
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  React.useEffect(() => {
    if (status !== "") {
      filter.jiraStatus = status;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });

      dispatch(getJiraRequestLog(paginationConfig));
    }

    if (type !== "") {
      filter.requestType = type;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });

      dispatch(getJiraRequestLog(paginationConfig));
    }

    if (searchState.length >= 5) {
      filter.agentPhoneNumber = searchState;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });

      dispatch(getJiraRequestLog(paginationConfig));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, type, searchState, dispatch]);

  const handleClear = () => {
    filter = {};
    paginationConfig.whereCondition = JSON.stringify(filter);

    setStatus("");
    setType("");
    setSearchState("");

    dispatch({
      type: "LOADING",
      payload: true,
    });

    // dispatch(getPOSDashboard(user.id));
    dispatch(getJiraRequestLog(paginationConfig));
  };

  React.useEffect(() => {
    dispatch(getBillTypesAction());
    dispatch({
      type: "LOADING",
      payload: true,
    });

    dispatch(getJiraRequestLog(paginationConfig));
    dispatch(complaintDashboard());

    return () => {
      dispatch({
        type: "TRANSACTIONS",
        payload: {},
      });
      dispatch({
        type: "DASHBOARD",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    let filter = {
      name: Agent,
      aggregatorId: user.id,
    };
    let search: any = {
      page: 1,
      pageSize: 10,
      id: user.id,
      whereCondition: JSON.stringify(filter),
    };
    if (Agent.length > 10) {
      dispatch(getAgentByPhoneNumber(search));
    }
  }, [dispatch, Agent, user.id, AgentName]);

  React.useEffect(() => {
    if (file?.fileName) {
      setUtilityName(file.fileName);
    }
  }, [file]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {      
      if (!alert.successful) {
        setButtonLoader(false);
        // display error message

        setcomplainErrorMessage(alert.message);
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      } else {
        setReference("");
        // enqueueSnackbar(alert.message, { variant: "success" });
        handleRefresh();
        setcomplainErrorMessage('');
        
        setResponseMessage(alert.message);
        setButtonLoader(false);
        dispatch({
          type: "LOADING",
          payload: false,
        });
        setComplainSuccessModal(true);
        dispatch({
          type: "ALERT_MODAL",
          payload: true,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
        setUtilityName("Choose file...");

        setBillType("0");
        setReference("");
        setBeneficiary("");

        setAmount("");
        setTerminalId("");

        setMaskPan("");
        setCustomerName("");
        setChoosenData("");
        setdisabledButton(true);
        setComplainMessage("");
        setAgentId("");
        setAgentName("");
        setAgent("");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);
  const getIndividualId = (id: any) => {
    history.push(`/logs/details/${id}`);
  };
  const handleLogComplaintModal = () => {
    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
  };

  const handleAgentName = (value: any) => {
    setAgent(value);
  };
  React.useEffect(() => {
    if (Object.entries(getAllegents).length === 0) {
      setAgentName("");
    } else {
      getAllegents.map((data: any) => {
        setAgentName(data.name);
        return setAgentId(data.id);
      });
    }
  }, [dispatch, Agent,getAllegents]);
  
  React.useEffect(() => {
    setComplainSuccessModal(false);
    dispatch({
      type: "ALERT_MODAL",
      payload: false,
    });
  }, [dispatch]);

  const handleComplainType = (value: any) => {
    setComplainType(value);
  };
  const handleSubmitButton = () => {
    setButtonLoader(true);
    setcomplainErrorMessage("");
    switch (ComplainType) {
      case "0":
        dispatch(createGeneralComplaintAction(ChoosenData));

        break;
      case "1":
        // console.log({ ...ChoosenData, type: "Bill type" });
        dispatch(createBillComplaintAction(ChoosenData));
        break;
      case "2":
        dispatch(createPOSComplaintAction(ChoosenData));
        // console.log({ ...ChoosenData, type: "POS" });
        break;
      case "3":
        dispatch(createFinanceComplaintAction(ChoosenData));
        // console.log({ ...ChoosenData, type: "Finance" });
        break;
      case "4":
        dispatch(createSavingsComplaintAction(ChoosenData));
        // console.log({ ...ChoosenData, type: "Savings" });
        break;
      default:
        break;
    }
  };
  const handleCopyNumber = () => {
    navigator.clipboard.writeText(ResponseMessage);
    enqueueSnackbar("Text copied to clipboard", { variant: "success" });
  };
  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          // height: '100vh',
        }}
      >
        <div
          className="col-md-11 ml-auto mr-auto p-0"
          style={{
            backgroundColor: PrimaryTheme.white,
            height: "100vh",
            position: "relative",
          }}
        >
          <h1
            className="mb-5 log-title"
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              textTransform: "uppercase",
              fontSize: PrimaryTheme.fontSizes?.subtitle,
            }}
          >
            Logs
          </h1>

          {/* cards  */}
          <div className="row mb-5 log-details-cover">
            <div
              className="col-md-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                LOGGED TICKETS
              </h5>
              <h3
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard.numberOfComplaints === null ||
                dashboard.numberOfComplaints === undefined
                  ? "-"
                  : dashboard.numberOfComplaints}
              </h3>
            </div>

            <div
              className="col-md-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                UNRESOLVED
              </h5>
              <h3
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard.pendingComplaints
                  ? dashboard.pendingComplaints
                  : "-"}
              </h3>
            </div>

            <div
              className="col-md-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                RESOLVED
              </h5>
              <h3
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard.resolvedComplaints
                  ? dashboard.resolvedComplaints
                  : "-"}
              </h3>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-md-12">
              {/* <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
               
              </div> */}
              <Filters
                name="Tickets"
                isLogs
                handleOpenModal={() => {
                  setComplainSuccessModal(false);
                  setcomplainErrorMessage("");
                  dispatch({
                    type: "ALERT_MODAL",
                    payload: true,
                  });
                }}
                status={status}
                statusChange={(e: any) => setStatus(e.target.value)}
                onClear={handleClear}
                logType={type}
                logTypeChange={(e: any) => setType(e.target.value)}
                hasSubtitle
                subtitle="NOTE: All Tickets Must Be Attended To Within 12 Hrs"
                searchState={searchState}
                handleSearch={(e: any) => setSearchState(e.target.value)}
              />
            </div>
          </div>

          <div className="row" style={{ paddingBottom: "150px" }}>
            <div className="col-md-12 mb-3">
              {list ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr className="text-center">
                          <th scope="col">S/N</th>
                          <th scope="col">Agent Id</th>
                          <th scope="col">Agent Name</th>
                          <th>Date</th>
                          <th scope="col">Log ID</th>
                          <th scope="col">Transaction Type</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Status</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 &&
                          list?.map((item: any, index: number) => (
                            <tr key={index} className="text-center">
                              <th scope="row">{getIndexSeed(index)}</th>
                              <td>
                                {item.agentPhoneNumber
                                  ? item.agentPhoneNumber
                                  : "-"}
                              </td>
                              <td>{item.agentName ? item.agentName : "-"}</td>
                              <td>{getDateTime(item.dateCreated)}</td>
                              <td>{item.logId ? item.logId : "-"}</td>
                              <td>
                                {item.requestTypeName
                                  ? item.requestTypeName
                                  : "-"}
                              </td>
                              <td>
                                {item.amount
                                  ? getCurrency(item.amount)
                                  : getCurrency("0")}
                              </td>
                              <td>
                                <span
                                  className={
                                    "badge badge-pill p-2 pl-3 pr-3 " +
                                    getColor(item.colorId)
                                  }
                                >
                                  {item.jiraStatus}
                                </span>
                              </td>

                              <td>
                                <SimplePopover
                                  popid={item.id}
                                  getId={getIndividualId}
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 && (
                    <React.Fragment>
                      <p className="text-center mt-3 text-dark w-100">
                        No result
                      </p>
                    </React.Fragment>
                  )}

                  <div className="col-md-12 p-0">
                    {logs.total > pageSize && (
                      <PaginationControlled
                        onPageSizeChange={handlePageSizeChange}
                        onChange={handleChange}
                        page={page}
                        total={logs.total && logs.total}
                        pageSize={pageSize}
                      />
                    )}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
      <AlertModal showClose={ComplainSuccessModal ? false : true}>
        {ComplainSuccessModal ? (
          <div>
            <div
              className="text-center"
              style={{
                marginTop: "60px",
                marginBottom: "20px",
                fontWeight: 700,
              }}
            >
              <div className="text-center" style={{ marginBottom: "20px" }}>
                <img src={Checked} alt="logo" />
              </div>
              Complaint Logged
            </div>
            <div className="text-center" style={{ marginBottom: "50px" }}>
              Your recent complaint has been logged successfully, and you will
              receive feedback from our support team shortly.
            </div>
            <div className="text-center" style={{ marginBottom: "40px" }}>
              <span
                style={{
                  padding: "20px",
                  background: "#4093D71A",
                  fontSize: "14px",
                  fontWeight: 700,
                }}
              >
                LOG ID: {ResponseMessage}
                <span
                  style={{
                    marginLeft: "20px",
                    cursor: "pointer",
                    color: PrimaryTheme.primary,
                  }}
                  onClick={handleCopyNumber}
                >
                  Copy
                </span>
                <span style={{ marginLeft: "2px" }}>
                  <img src={Copy} alt="copy" />
                </span>
              </span>
            </div>
            <div className="text-center" style={{ marginBottom: "50px" }}>
              <button
                style={{
                  background: PrimaryTheme.primary,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.white,
                  width: "120px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  borderRadius: "6px",
                }}
                className="text-bold border-0 col-md-6"
                onClick={() =>
                  dispatch({
                    type: "ALERT_MODAL",
                    payload: false,
                  })
                }
              >
                Close
              </button>
            </div>
          </div>
        ) : (
          <div className="col-md-12 p-5 text-center comission__modal__cover">
            <div className="col-md-12 ">
              <span
                className="badge-pill text-center p-3 d-block col-md-7 col-12 ml-auto mr-auto withdraw-comission-header"
                style={{
                  background: PrimaryTheme.warn,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                Log a New Complaint
              </span>
            </div>
            {complainErrorMessage!=='' ? (
              <div
                className="alert alert-danger"
                role="alert"
                style={{ marginTop: "20px" }}
              >
                {complainErrorMessage}
              </div>
            ) : (
              ""
            )}

            <div className="form-group mt-4 text-left">
              <div className="form-group mt-4 text-left">
                <label
                  htmlFor="agentName"
                  style={{
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                    color: PrimaryTheme.dark,
                  }}
                >
                  Complaint Type
                </label>
                <select
                  name="logType"
                  id="logType"
                  className="custom-select bg-light outline-0 border-0"
                  onChange={(evt) => handleComplainType(evt.target.value)}
                >
                  <option value={"0"}>General</option>
                  <option value={"1"}>Bill Payment</option>
                  <option value={"2"}>POS Cash Withdrawal</option>
                  <option value={"3"}>Finance</option>
                  <option value={"4"}>Savings</option>
                </select>
              </div>
              <label
                htmlFor="agentName"
                style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.dark,
                }}
              >
                Agent Phone Number
              </label>
              <Input
                type="number"
                placeholder="Agent Phone Number"
                autoComplete="agentName"
                showIcon
                required
                id="agentName"
                value={Agent}
                inputMode="text"
                onChange={(evt) => handleAgentName(evt.target.value)}
                isInput
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  color: PrimaryTheme.dark,
                  background: "#F4F7FC",
                }}
              />
            </div>
            <div className="form-group mt-4 text-left">
              <label
                htmlFor="agentName"
                style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.dark,
                }}
              >
                Agent Name
              </label>
              <Input
                type="tel"
                placeholder="Agent Name"
                autoComplete="agentName"
                showIcon
                required
                disabled
                id="agentName"
                value={AgentName}
                inputMode="text"
                isInput
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  color: PrimaryTheme.dark,
                  background: "#F4F7FC",
                }}
              />
            </div>

            {ComplainType === "1" ? (
              <div>
                <div className="form-group mt-4 text-left">
                  <label
                    htmlFor="agentName"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.dark,
                    }}
                  >
                    Select Bill Type
                  </label>
                  <select
                    name="logType"
                    id="logType"
                    value={BillType}
                    className="custom-select bg-light outline-0 border-0"
                    onChange={(evt) => setBillType(evt.target.value)}
                  >
                    <option value={""}>Select Bill</option>
                    {getBillType.map((list: any) => (
                      <option value={list.id} key={list.id}>
                        {list.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group mt-4 text-left">
                  <label
                    htmlFor="reference"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.dark,
                    }}
                  >
                    Beneficiary
                  </label>
                  <Input
                    type="tel"
                    placeholder=" Beneficiary"
                    autoComplete=" Beneficiary"
                    showIcon
                    required
                    value={Beneficiary}
                    onChange={(evt) => setBeneficiary(evt.target.value)}
                    id="beneficiary"
                    inputMode="text"
                    isInput
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      background: "#F4F7FC",
                    }}
                  />
                </div>

                <div className="form-group mt-4 text-left">
                  <label
                    htmlFor="reference"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.dark,
                    }}
                  >
                    Amount
                  </label>
                  <Input
                    type="number"
                    placeholder=" Amount"
                    autoComplete=" Amount"
                    showIcon
                    required
                    value={Amount}
                    onChange={(evt) => setAmount(evt.target.value)}
                    id=" Amount"
                    inputMode="text"
                    isInput
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      background: "#F4F7FC",
                    }}
                  />
                </div>
              </div>
            ) : (
              ""
            )}

            {/* POS Withdrawal Form */}

            {ComplainType === "2" ? (
              <div>
                <div className="form-group mt-4 text-left">
                  <label
                    htmlFor="reference"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.dark,
                    }}
                  >
                    Terminal ID
                  </label>
                  <Input
                    type="tel"
                    placeholder="Terminal ID"
                    autoComplete="terminalID"
                    showIcon
                    required
                    id="terminalID"
                    inputMode="text"
                    value={TerminalId}
                    onChange={(evt) => setTerminalId(evt.target.value)}
                    isInput
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      background: "#F4F7FC",
                    }}
                  />
                </div>

                <div className="form-group mt-4 text-left">
                  <label
                    htmlFor="reference"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.dark,
                    }}
                  >
                    Masked Pan
                  </label>
                  <Input
                    type="tel"
                    placeholder="Masked Pan"
                    autoComplete="Masked Pan"
                    showIcon
                    required
                    value={MaskPan}
                    onChange={(evt) => setMaskPan(evt.target.value)}
                    id="MaskedPan"
                    inputMode="text"
                    isInput
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      background: "#F4F7FC",
                    }}
                  />
                </div>

                <div className="form-group mt-4 text-left">
                  <label
                    htmlFor="reference"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.dark,
                    }}
                  >
                    Amount
                  </label>
                  <Input
                    type="tel"
                    placeholder=" Amount"
                    autoComplete=" Amount"
                    showIcon
                    required
                    value={Amount}
                    onChange={(evt) => setAmount(evt.target.value)}
                    id=" Amount"
                    inputMode="text"
                    isInput
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      background: "#F4F7FC",
                    }}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            {/* finance */}
            {ComplainType === "3" ? (
              <div>
                <div className="form-group mt-4 text-left">
                  <label
                    htmlFor="reference"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.dark,
                    }}
                  >
                    Amount
                  </label>
                  <Input
                    type="tel"
                    placeholder=" Amount"
                    autoComplete=" Amount"
                    showIcon
                    required
                    value={Amount}
                    onChange={(evt) => setAmount(evt.target.value)}
                    id=" Amount"
                    inputMode="text"
                    isInput
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      background: "#F4F7FC",
                    }}
                  />
                </div>
              </div>
            ) : (
              ""
            )}

            {/* savings */}
            {ComplainType === "4" ? (
              <div>
                <div className="form-group mt-4 text-left">
                  <label
                    htmlFor="reference"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.dark,
                    }}
                  >
                    Customer Number
                  </label>
                  <Input
                    type="tel"
                    placeholder=" Customer Number"
                    autoComplete=" Customer Number"
                    showIcon
                    required
                    value={CustomerName}
                    onChange={(evt) => setCustomerName(evt.target.value)}
                    id=" customerNumber"
                    inputMode="text"
                    isInput
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      background: "#F4F7FC",
                    }}
                  />
                </div>

                <div className="form-group mt-4 text-left">
                  <label
                    htmlFor="reference"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.dark,
                    }}
                  >
                    Amount
                  </label>
                  <Input
                    type="tel"
                    placeholder=" Amount"
                    autoComplete=" Amount"
                    showIcon
                    required
                    value={Amount}
                    onChange={(evt) => setAmount(evt.target.value)}
                    id=" Amount"
                    inputMode="text"
                    isInput
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      background: "#F4F7FC",
                    }}
                  />
                </div>
              </div>
            ) : (
              ""
            )}

            <div className="form-group mt-4 text-left">
              <label
                htmlFor="reference"
                style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.dark,
                }}
              >
                Reference
              </label>
              <Input
                type="tel"
                placeholder="Reference"
                autoComplete="reference"
                showIcon
                required
                id="reference"
                value={Reference}
                inputMode="text"
                onChange={(evt) => setReference(evt.target.value)}
                isInput
                style={{
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  color: PrimaryTheme.dark,
                  background: "#F4F7FC",
                }}
              />
            </div>

            {/* upload agent file */}

            <div className="form-group">
              <h6
                className="w-100"
                style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.dark,
                  textAlign: "left",
                }}
              >
                Upload File
              </h6>

              <label
                htmlFor="utility"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  background: "#F4F7FC",
                  borderRadius: 25,
                  border: "1px solid white",
                  padding: 15,
                  height: "auto",
                  boxShadow: "none",
                  width: "100%",
                  cursor: "pointer",
                }}
              >
                <input
                  type="file"
                  placeholder="Upload Utility Bill"
                  id="utility"
                  value={utility}
                  disabled={submitted}
                  onChange={(e) =>
                    handleFile(e.currentTarget.files, "complain")
                  }
                  style={{
                    fontFamily: PrimaryTheme.fonts?.RubikLight,
                    color: PrimaryTheme.dark,
                    background: "#F4F7FC",
                    display: "none",
                  }}
                />

                <div className="row justify-content-between align-items-center m-0">
                  <span>{truncateString(utilityName, 30)}</span>
                  <span
                    className="badge badge-pill badge-warning p-2 pl-3 pr-3 btn-lg"
                    style={{
                      fontSize: PrimaryTheme.fontSizes?.normal,
                    }}
                  >
                    {utilityName !== "Choose file..." ? "Change" : "Upload"}
                  </span>
                </div>
              </label>
            </div>
            {/* end upload agent file */}
            <div className="form-group mt-4 text-left">
              <label
                htmlFor="agentName"
                style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.dark,
                }}
              >
                Complaint Message <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                placeholder="Complaint Message"
                required
                id="agentName"
                onChange={(evt) => setComplainMessage(evt.target.value)}
                value={ComplainMessage}
                inputMode="text"
                rows={5}
                className="form-control"
              ></textarea>
            </div>

            <div
              style={{
                paddingTop: "40px",
                paddingBottom: "20px",
                textAlign: "center",
              }}
            >
              {ButtonLoader ? (
                <Input
                  type="button"
                  disabled
                  isInput
                  value={"Please wait..."}
                  style={{
                    background: PrimaryTheme.primary,
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                    color: PrimaryTheme.white,
                  }}
                  className="text-bold border-0 col-md-6"
                />
              ) : (
                <Input
                  type="button"
                  disabled={disabledButton}
                  isInput
                  value={"Log Complaint"}
                  style={{
                    background: PrimaryTheme.primary,
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                    color: PrimaryTheme.white,
                  }}
                  onClick={handleSubmitButton}
                  className="text-bold border-0 col-md-6"
                />
              )}
            </div>
          </div>
        )}
      </AlertModal>
    </React.Fragment>
  );
}

interface Dashboard {
  numberOfComplaints?: any;
  pendingComplaints?: any;
  resolvedComplaints?: any;
}
